module.exports = __webpack_public_path__ + "static/media/howitworks-image.a099451e.png";